import { useState } from "react";
import { Popover, MenuItem, IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import VisibilityIcon from "@mui/icons-material/Visibility";
import GavelIcon from "@mui/icons-material/Gavel";
import { TransactionSheet } from "./transaction-sheet";
import { useNavigate } from "react-router-dom";
const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1.5),
  fontSize: "0.875rem",
  padding: theme.spacing(1, 2),
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
  },
}));

const PopoverContent = styled("div")(({ theme }) => ({
  minWidth: 180,
  padding: theme.spacing(0.5),
  borderRadius: theme.shape.borderRadius,
}));

export function TransactionActionsPopover({ transaction }) {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const [sheetOpen, setSheetOpen] = useState(false);
  const isOpen = Boolean(anchorEl);

  const handleCreateDispute = () => {
    handleClose();
    navigate("/disputes/chargebacks", {
      state: { createDisputeTransaction: transaction },
    });
  };

  const handleOpen = (e) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  const handleView = () => {
    handleClose();
    setSheetOpen(true);
  };

  return (
    <>
      <IconButton size="small" onClick={handleOpen}>
        <MoreVertIcon fontSize="small" />
      </IconButton>
      <Popover
        open={isOpen}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{
          paper: { elevation: 2, sx: { borderRadius: "8px", mt: 0.5 } },
        }}
      >
        <PopoverContent>
          <StyledMenuItem onClick={handleView}>
            <VisibilityIcon fontSize="small" />
            View
          </StyledMenuItem>
          <StyledMenuItem onClick={handleCreateDispute}>
            <GavelIcon fontSize="small" />
            Create Dispute
          </StyledMenuItem>
        </PopoverContent>
      </Popover>

      <TransactionSheet
        open={sheetOpen}
        onClose={() => setSheetOpen(false)}
        transaction={transaction}
      />
    </>
  );
}
